<div class="row">
    <div class="col-md-4 mb-3">
        <div class="auto-complete">
            <label [for]="idPrefix + 'City'" class="form-label">Città</label>
            <input type="text" class="form-control" [id]="idPrefix + 'City'" [name]="idPrefix + 'City'"
                [ngModel]="city" (ngModelChange)="onCityInput($event)" [required]="required" autocomplete="off" />
            <ul *ngIf="suggestions.length > 0">
                <li *ngFor="let s of suggestions" (click)="selectSuggestion(s)">
                    {{ s.name }} <span class="text-muted">({{ s.provinceAbbr }})</span>
                </li>
            </ul>
        </div>
    </div>
    <div class="col-md-4 mb-3" *ngIf="showProvince">
        <label [for]="idPrefix + 'Province'" class="form-label">Provincia</label>
        <input type="text" class="form-control" [id]="idPrefix + 'Province'" [value]="province || ''" readonly />
    </div>
    <div class="col-md-4 mb-3" *ngIf="showPostalCode">
        <label [for]="idPrefix + 'PostalCode'" class="form-label">CAP</label>
        <select class="form-select" [id]="idPrefix + 'PostalCode'" [name]="idPrefix + 'PostalCode'"
            [ngModel]="postalCode" (ngModelChange)="onPostalCodeChange($event)" [required]="required">
            <option value=""></option>
            <option *ngFor="let cap of effectiveCapOptions" [value]="cap">{{ cap }}</option>
        </select>
    </div>
</div>
